import { Component, Inject, OnInit } from '@angular/core';
import { SettingsService } from '../settings.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-add-new-level',
  templateUrl: './add-new-level.component.html',
  styleUrls: ['./add-new-level.component.scss']
})
export class AddNewLevelComponent implements OnInit {
	levelName: any;
	blockLoader: string = 'blockLoader';
	currentHierarchies: any;
	organisationId: any;
	index: any;

	constructor(
		private dialogRef: MatDialogRef<AddNewLevelComponent>,
		private settingsService: SettingsService,
		private ngxSpinnerService: NgxSpinnerService,
		private snackbar: MatSnackBar,
		@Inject(MAT_DIALOG_DATA) private data: any
	) {
		console.log('dataaa',data)
		if(data) {
			this.currentHierarchies = data.currentHierarchies;
			this.organisationId = data.organisationId;
			if(data.editData) {
				this.levelName = data.editData;
			}
			this.index = data.index;
		}

	}

	ngOnInit(): void {

	}

	isSaveDisabled() {
		return this.levelName?.length <= 0;
	}

	async saveNewLevel() {
		if (this.levelName && this.levelName.trim().length >= 1) {
			this.levelName = this.levelName.trim();
			const newLevelName = this.levelName.toLowerCase();
			await this.ngxSpinnerService.show("blockLoader");
			// console.log(data);
			if (this.index) {
				this.currentHierarchies[this.index] = newLevelName;
			} else {
				this.currentHierarchies[this.currentHierarchies.length] = newLevelName;
			}
			await this.settingsService.saveNewLevel(this.currentHierarchies, this.organisationId);
			await this.ngxSpinnerService.hide("blockLoader");
			this.dialogRef.close("success");
		}
	}

	hierarchyValueTracker(index: number, item: any) {
		return index;
	}

}
